import React, { useLayoutEffect } from 'react';

import type { RouteComponentProps } from 'react-router';

import { MainLayoutContainer } from './MainLayout.container';
import { LoadingPanel } from '../components/common/LoadingPanel';

export const SwitchSubscription: React.FC<RouteComponentProps<{}, any>> = ({ router, params }) => {
  const { subId } = params;

  useLayoutEffect(() => {
    router.push(`/subscription/${subId}`);
  }, [subId]);

  return (
    <MainLayoutContainer displayNavBar={true} location={window.location}>
      <LoadingPanel loadingMessage="Switching subscription..." />
    </MainLayoutContainer>
  );
};
